export default __webpack_public_path__ + "static/media/ztsh-logo.c5e4761a.png";